import { createContext } from '@chakra-ui/react-utils';
import { type SystemStyleObject } from '@chakra-ui/react-v2';

import type { TablePart } from './types';

export type TableStyles = Partial<Record<TablePart, SystemStyleObject>>;

const [TableStylesProvider, useTableStyles] = createContext<TableStyles>({
  name: 'TableStylesContext',
  strict: false,
  errorMessage:
    'useTableStyles: `context` is undefined. Seems you used a TableV2 sub-component that required a styles context outside of a TableContainer wrapping box.',
});

export { TableStylesProvider, useTableStyles };
